import { Component, OnInit, HostBinding, Input } from '@angular/core';
import * as _ from 'lodash';
import IAllowedUse = ZoneIQCalibration.IAllowedUse;
import { TableType } from 'src/shared/enums';
import ICalibrationUsesLabel = ZoneIQCalibration.ICalibrationUsesLabel;
import { ZoningCodeAttribute } from 'src/app/models/calibrations/zoning-code-models/zoning-code-attribute.model';
import { TableFieldService } from 'src/app/core/services/table-field.service';
import { ZoningCodeService } from 'src/app/core/services/zoning-code.service';
import { IAttributesIdentifiers } from 'src/app/interfaces/attributes-identifiers.interface';
import IUseClass = ZoneIQCalibration.IUseClass;
import IGridicsUseTag = ZoneIQCalibration.IGridicsUseTag;
import { CalibrationUsesLabelModel } from 'src/app/models/calibrations/calibration-uses-label.model';
import { SyncService } from 'src/app/core/services/sync.service';

const EMPTY_ATTR_FLAGS = {};

@Component({
    standalone: false,
    selector: 'use-type-table',
    templateUrl: './use-type-table.component.html',
    styleUrls: ['./use-type-table.component.scss']
})
export class UseTypeTableComponent implements OnInit {
    useClassOptions: IUseClass[] = [];
    gridicsUseTags: IGridicsUseTag[] = [];

    @HostBinding('class')
    readonly hostClass = 'use-type-table';

    @Input()
    useType?: any;

    @Input()
    columns?: any;

    @Input()
    visibilityOptions?: any;

    @Input()
    useAllowances: IAllowedUse[];

    @Input()
    currentTab: string;

    @Input()
    hideAttributeButtons: boolean = false;

    @Input()
    readOnly: boolean = false;

    private _labelIdentifiers: { [property: number]: IAttributesIdentifiers } = {};

    private _attributeFlagsIdentifiers: { [property: number]: string } = {};

    constructor(
        protected tableFieldService: TableFieldService,
        protected zoningCodeService: ZoningCodeService,
        public readonly syncService: SyncService
    ) {}

    ngOnInit() {
        this.useClassOptions = this.zoningCodeService.useClasses;
        this.gridicsUseTags = this.zoningCodeService.gridicsUseTags;
    }

    getIdentifiers(label: ICalibrationUsesLabel) {
        if (!label) {
            return;
        }

        if (!this._labelIdentifiers[label.Id]) {
            this._labelIdentifiers[label.Id] = {
                tableField: label,
                tableType: TableType.CALIBRATION_USES
            };
        }
        return this._labelIdentifiers[label.Id];
    }

    getAttributesFlags(label: ICalibrationUsesLabel) {
        if (!this._attributeFlagsIdentifiers[label.Id]) {
            this._attributeFlagsIdentifiers[label.Id] = ZoningCodeAttribute.getIdentifier({
                TableType: TableType.CALIBRATION_USES,
                TableFieldId: label.Id,
                ZoningCodeId: this.zoningCodeService.selectedZoningCode.Id
            });
        }
        return (
            this.zoningCodeService.selectedZoningCode.attributes.ZoningCodeAttributesStatistics.get(
                this._attributeFlagsIdentifiers[label.Id]
            ) || EMPTY_ATTR_FLAGS
        );
    }

    getIsValidUseClass(label: ICalibrationUsesLabel) {
        const useClass = this.useClassOptions.find(uc => uc.Id === label.ClassId);
        const importValidationResult = _.get(useClass, 'importValidationResult');
        return !importValidationResult || importValidationResult.isValid;
    }

    getIsValidGridicsUseTag(label: ICalibrationUsesLabel) {
        const gridicsUseTag = this.gridicsUseTags.find(tag => tag.Id === label.GridicsUseTagId);
        const importValidationResult = _.get(gridicsUseTag, 'importValidationResult');
        return !importValidationResult || importValidationResult.isValid;
    }

    handleClassIdManualChange(label: CalibrationUsesLabelModel) {
        label.markManuallyChangedProperty('ClassId');
    }

    handleClassIdValueChange(label: CalibrationUsesLabelModel) {
        if (label.getIsOriginalState('ClassId')) {
            return;
        }
        this.syncService.triggerChangeDetection();
    }

    handleGridicsUseTagIdManualChange(label: CalibrationUsesLabelModel) {
        label.markManuallyChangedProperty('GridicsUseTagId');
    }

    handleGridicsUseTagIdValueChange(label: CalibrationUsesLabelModel) {
        if (label.getIsOriginalState('GridicsUseTagId')) {
            return;
        }
        this.syncService.triggerChangeDetection();
    }
}
